import { processSilentRenew } from 'redux-oidc';

export const SilentRenew = () => { processSilentRenew(); return null; };
